import { useCallback, useEffect, useRef, useState } from "react";
import { Spin, Table, message as antMessage } from "antd";
import dayjs from "dayjs";
import { serverFetch } from "@core/server";
import Dialog from "../../dialogs/dialog";
import { dictsChannelVidName } from "../../dialogs/channel-vids";

const PredDialogs = ({ idPred }) => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalDialogId, setModalDialogId] = useState(null);
  const [messages, setMessages] = useState([]);
  const [messagesLoading, setMessagesLoading] = useState(false);
  const messagesEndRef = useRef(null);

  const scrollToBottom = useCallback(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, []);

  const load = useCallback(() => {
    if (!idPred) return;
    setLoading(true);
    serverFetch("Message/Dialog", {
      queryParams: {
        idPred,
        deleted: false,
        begPer: dayjs().subtract(5, "year").startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
        endPer: dayjs().add(1, "day").endOf("day").format("YYYY-MM-DDTHH:mm:ss")
      }
    })
      .then((data) => setList(Array.isArray(data) ? data : []))
      .catch((e) => antMessage.error(e?.message || "Не удалось загрузить диалоги"))
      .finally(() => setLoading(false));
  }, [idPred]);

  useEffect(load, [load]);

  useEffect(() => {
    if (!modalDialogId) {
      setMessages([]);
      return;
    }
    setMessagesLoading(true);
    serverFetch("Message/Message", { queryParams: { dialogId: modalDialogId } })
      .then((data) => {
        setMessages(Array.isArray(data) ? data : []);
        setTimeout(scrollToBottom, 50);
      })
      .catch((e) => antMessage.error(e?.message || "Ошибка"))
      .finally(() => setMessagesLoading(false));
  }, [modalDialogId, scrollToBottom]);

  const columns = [
    { title: "#", dataIndex: "id", width: 72 },
    {
      title: "Канал",
      key: "channel",
      ellipsis: true,
      render: (_, d) => d.channelName || dictsChannelVidName(d.vid) || ""
    },
    { title: "Наименование", dataIndex: "name", ellipsis: true },
    {
      title: "Обновлён",
      dataIndex: "lastUpdated",
      width: 150,
      render: (v) => (v ? dayjs(v).format("DD.MM.YYYY HH:mm") : "")
    }
  ];

  return (
    <div className="spr-pred-dialogs">
      <Spin spinning={loading}>
        <Table
          size="small"
          rowKey="id"
          columns={columns}
          dataSource={list}
          pagination={false}
          locale={{ emptyText: "Нет связанных диалогов" }}
          onRow={(record) => ({
            onClick: () => setModalDialogId(record.id)
          })}
        />
      </Spin>
      {modalDialogId != null && (
        <Dialog
          id={modalDialogId}
          onClose={() => {
            setModalDialogId(null);
            load();
          }}
          messages={messages}
          setMessages={setMessages}
          messagesLoading={messagesLoading}
          messagesEndRef={messagesEndRef}
          scrollToBottom={scrollToBottom}
          onSent={load}
        />
      )}
    </div>
  );
};

export default PredDialogs;
